import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccessTimeFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.99405 15.7299C0.93461 10.7563 3.29631 5.05461 8.26994 2.99409C13.2438 0.933478 18.9454 3.29643 21.0059 8.26992C23.0665 13.2438 20.7035 18.9454 15.7301 21.0059C10.7562 23.0665 5.05452 20.7034 2.99405 15.7299ZM12.468 7.98499C12.468 7.57077 12.1322 7.23499 11.718 7.23499C11.3038 7.23499 10.968 7.57077 10.968 7.98499V12.636C10.968 12.8975 11.1043 13.1402 11.3276 13.2764L14.9836 15.5054C15.3372 15.721 15.7987 15.6091 16.0144 15.2554C16.23 14.9017 16.1181 14.4402 15.7644 14.2246L12.468 12.2148V7.98499Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgAccessTimeFilled);
export default ForwardRef;
